// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"_2LI30Lgt-wD3orDIpqrR12"};